import _ from 'underscore';
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Text } from '@bingads-webui-react/fabric-control';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { PropertyRow } from '@bingads-webui-campaign-react/ui-generator';

const formatKeywords = ({ i18n, data, showLength }) => {
  if (_.isEmpty(data) || data.total === 0 || _.isEmpty(data.value)) {
    return i18n.getString(_TL_('No keyword'));
  }
  const len = data.total;
  if (len > showLength) {
    let detail = data.value.slice(0, showLength).map(keyword => keyword.Text).join(i18n.getString(_TL_(', ')));
    detail += i18n.getString(_TL_('... +{{count}} more'), { count: len - showLength });
    return detail;
  }
  return data.value.map(keyword => keyword.Text).join(i18n.getString(_TL_(', ')));
};

export const Keywords = ({ data, showLength }) => {
  const i18n = useContext(I18nContext);

  return (
    <PropertyRow propertyLabel={{ label: _TL_('Keywords') }}>
      <Text block style={{ 'white-space': 'normal' }} >{formatKeywords({ i18n, data, showLength })}</Text>
    </PropertyRow>
  );
};

Keywords.propTypes = {
  data: PropTypes.shape({
    value: PropTypes.arrayOf(PropTypes.shape({
      Text: PropTypes.string,
    })),
    total: PropTypes.number,
  }),
  showLength: PropTypes.number,
};

Keywords.defaultProps = {
  data: {},
  showLength: 10,
};
